import { createDuck, createEntityCollection } from '@/utils'
import { getRecommend } from '@/services/api/common'

import {
  getOrderList,
  delOrder,
  refoundOrder,
  getOrderDetailById,
  cancelOrder,
  receiveOrder,
} from '@/services/api/orders'
import { delArrayItemByEle } from '@/utils/ordersUtils'
import { ORDER_STATUS_MAP, ORDER_ACTIONS_TYPES } from '@/utils/mineConst'
import { Toast } from 'antd-mobile-v2'
/** @type {orders.OrdersStateType} */
export const DEFAULT_STATUS = {
  status: 0,
  list: [],
  entities: {},
  total: 0, //接口返回
  totalLocal: 0, //本地拉取到的总量
}
export const duck = createDuck({
  name: 'ordersDuck',
  /** @type {{[key: string]: orders.OrdersStateType,recommendList?: Array<GoodItemInfo>}} */
  initialState: {},
  actions: {
    /**
     * 获取订单列表
     * @param {object} opt
     * @param {string} opt.tabId
     * @param {number} opt.lastOrderId
     * @param {number} opt.pageSize
     * @returns
     */
    fetchData(opt) {
      return async (dispatch, getState) => {
        const { tabId, lastOrderId, pageSize } = opt
        const { ordersDuck } = getState()
        const { data, error } = await getOrderList({
          lastOrderId: lastOrderId,
          pageSize: pageSize,
          status: parseInt(tabId),
        })
        if (!error) {
          const { data: _list, total } = data

          const { list, entities } = createEntityCollection(_list, item => item.orderId)
          const _curTime = new Date().getTime()
          const { nowTime } = _list[0] || {}
          window.TIME_DIFF = nowTime ? nowTime - _curTime : 0
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                list,
                entities,
                status: 1,
                total: total,
                totalLocal: list.length,
                hasMore: total > list.length,
              },
            }),
          )
          if (total < pageSize) {
            dispatch(duck.getRecommendData())
          }
        } else {
          Toast.show(error.message || '获取订单列表失败')
        }
      }
    },
    /**
     * 获取订单列表
     * @param {object} opt
     * @param {string} opt.tabId
     * @param {number} opt.lastOrderId
     * @param {number} opt.pageSize
     *
     * @returns
     */
    fetchMore(opt) {
      return async (dispatch, getState) => {
        const { tabId, lastOrderId, pageSize } = opt
        const { ordersDuck } = getState()
        const preData = ordersDuck[tabId] || {}
        const { data, error } = await getOrderList({
          lastOrderId: lastOrderId,
          pageSize: pageSize,
          status: parseInt(tabId),
        })
        if (!error) {
          const { data: _list, total } = data
          const { list, entities } = createEntityCollection(_list, item => item.orderId)
          const { list: preList, entities: preEnt, totalLocal } = preData
          const newList = preList.concat(list)
          const newEnt = {
            ...entities,
            ...preEnt,
          }
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                list: newList,
                entities: newEnt,
                status: 1,
                total: total,
                totalLocal: list.length + totalLocal,
                hasMore: total > list.length + totalLocal,
              },
            }),
          )
        }
      }
    },

    getRecommendData() {
      return async (dispatch, getState) => {
        const { error, data } = await getRecommend()

        if (!error) {
          const { ordersDuck } = getState()

          dispatch(
            duck.change({
              ...ordersDuck,
              recommendList: data,
            }),
          )
        }
      }
    },

    /**
     * 删除订单
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    del(tabId, orderId) {
      //delOrder
      return async (dispatch, getState) => {
        const { error } = await delOrder(orderId)
        if (!error) {
          const { ordersDuck } = getState()
          const { list, entities, ...ot } = ordersDuck[tabId]
          const newEnt = { ...entities }
          delete newEnt[orderId]
          const newList = delArrayItemByEle(list, orderId)
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                ...ot,
                list: [...newList],
                entities: { ...newEnt },
              },
            }),
          )
        } else {
          Toast.show('订单删除失败，请稍后重试')
        }
      }
    },

    /**
     * 申请退款
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    refound(tabId, orderId) {
      return async (dispatch, getState) => {
        const { error } = await refoundOrder(orderId)
        if (!error) {
          //在待收货列表里 申请退款之后就需要删除数据
          if (tabId === '4') {
            dispatch(duck.delByLocal(tabId, orderId))
            return
          }
          const { data } = await getOrderDetailById(orderId)
          const { ordersDuck } = getState()
          const { entities } = ordersDuck[tabId]
          const _d = data ? data : { ...entities[orderId], status: ORDER_STATUS_MAP.REFUNDED }
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                ...ordersDuck[tabId],
                entities: {
                  ...entities,
                  [orderId]: {
                    ..._d,
                  },
                },
              },
            }),
          )
        } else {
          Toast.show('退款失败，请联系客服处理')
        }
      }
    },

    /**
     * 前端删除数据
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    delByLocal(tabId, orderId) {
      return async (dispatch, getState) => {
        const { ordersDuck } = getState()
        const { list, entities, ...ot } = ordersDuck[tabId]
        const newEnt = { ...entities }
        delete newEnt[orderId]
        const newList = delArrayItemByEle(list, orderId)
        dispatch(
          duck.change({
            ...ordersDuck,
            [tabId]: {
              ...ot,
              list: [...newList],
              entities: { ...newEnt },
            },
          }),
        )
      }
    },

    /**
     * 取消订单
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    timeout(tabId, orderId) {
      return async (dispatch, getState) => {
        //在待付款列表里 取消订单就需要删除数据
        if (tabId === '2') {
          dispatch(duck.delByLocal(tabId, orderId))
          return ORDER_ACTIONS_TYPES.CANCEL
        }
        const { data } = await getOrderDetailById(orderId)
        const { ordersDuck } = getState()
        const { entities } = ordersDuck[tabId]
        const _d = data ? data : { ...entities[orderId], status: ORDER_STATUS_MAP.CANCELED }
        dispatch(
          duck.change({
            ...ordersDuck,
            [tabId]: {
              ...ordersDuck[tabId],
              entities: {
                ...entities,
                [orderId]: {
                  ..._d,
                },
              },
            },
          }),
        )
        return ORDER_ACTIONS_TYPES.CANCEL
      }
    },
    /**
     * 取消订单
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    cancel(tabId, orderId) {
      return async (dispatch, getState) => {
        const { error } = await cancelOrder(orderId)
        if (!error) {
          //在待付款列表里 取消订单就需要删除数据
          if (tabId === '2') {
            dispatch(duck.delByLocal(tabId, orderId))
            return ORDER_ACTIONS_TYPES.CANCEL
          }
          const { data } = await getOrderDetailById(orderId)
          const { ordersDuck } = getState()
          const { entities } = ordersDuck[tabId]
          const _d = data ? data : { ...entities[orderId], status: ORDER_STATUS_MAP.CANCELED }
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                ...ordersDuck[tabId],
                entities: {
                  ...entities,
                  [orderId]: {
                    ..._d,
                  },
                },
              },
            }),
          )
          return ORDER_ACTIONS_TYPES.CANCEL
        } else {
          Toast.show('订单取消失败，请重试')
        }
      }
    },

    /**
     * 签收订单 确认收货
     * @param {string} tabId
     * @param {number} orderId
     * @returns
     */
    receive(tabId, orderId) {
      return async (dispatch, getState) => {
        const { error } = await receiveOrder(orderId)
        if (!error) {
          //在待收货列表里 确认收货之后就需要删除数据
          if (tabId === '4') {
            dispatch(duck.delByLocal(tabId, orderId))
            return ORDER_ACTIONS_TYPES.RECEIVE
          }
          const { data } = await getOrderDetailById(orderId)
          const { ordersDuck } = getState()
          const { entities } = ordersDuck[tabId]
          const _d = data ? data : { ...entities[orderId], status: ORDER_STATUS_MAP.FINISHED }
          dispatch(
            duck.change({
              ...ordersDuck,
              [tabId]: {
                ...ordersDuck[tabId],
                entities: {
                  ...entities,
                  [orderId]: {
                    ..._d,
                  },
                },
              },
            }),
          )
          return ORDER_ACTIONS_TYPES.RECEIVE
        } else {
          Toast.show('确认收货失败，请稍后重试')
        }
      }
    },
  },
})
